<div class="container-fluid ptCustom">
    <div class="row mt-4 submitMemberNews">
        <div class="col-12">
            <div class="submitMemberNewsWrap mt-4">
                <form [formGroup]="memberNewsForm" class="submitMemberNewsForm">
                    <div class="row gx-5">
                        <div class="col-md-8">
                            <div class="mb-4">
                                <label for="postingAs" class="form-label">Posting As</label>
                                <input formControlName="postingAs" type="text" class="form-control" id="postingAs" placeholder="Posting As...">
                                <div *ngIf="postingAsCtrl.invalid && (postingAsCtrl.dirty || postingAsCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="articleTitle" class="form-label">Article Title</label>
                                <input formControlName="articleTitle" type="text" class="form-control" id="articleTitle" placeholder="Article Title">
                                <div *ngIf="articleTitleCtrl.invalid && (articleTitleCtrl.dirty || articleTitleCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="articleContent" class="form-label">Article Content</label>
                                <!--<textarea formControlName="articleContent" class="form-control" id="articleContent" rows="12"></textarea>-->
                                <editor class="form-control" formControlName="articleContent" licenseKey="gpl" toolbar="false" menubar="false" [init]="{
                                    base_url: '/tinymce',
                                    suffix: '.min',
                                    menubar: false,
                                    statusbar: false,
                                    skin: '../../../assets/css/tinymce',
                                    content_style: 'body { color: #FFFFFF; }',
                                    height: 350,
                                }"></editor>
                                <div *ngIf="articleContentCtrl.invalid && (articleContentCtrl.dirty || articleContentCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-4">
                                <label for="articleImg" class="form-label">Main Image <a href="javascript:void(0);" class="formTooltip" placement="right" ngbTooltip="Allowed file types: png jpg jpeg gif bmp svg webp
                                    Pro tip: Headline text will overlay the image, so avoid distracting graphics or heavy copy.
                                    A horizontal image is recommended."><i class="fa-solid fa-circle-question"></i></a></label>
                                <input (change)="updateMainImage($event.target)" class="form-control" type="file" id="articleImg">
                            </div>
                            <div class="mb-4">
                                <label for="articleImg" class="form-label">Image Preview</label>
                                <div class="imagePreview adPreview" ><img [src]="preview"/></div>
                            </div>
                            <div class="mb-3">
                                <div class="attachmentWrap">
                                    <div class="mb-3">
                                        <label for="articleAtt" class="form-label">Attachments <a href="javascript:void(0);" class="formTooltip" placement="top" ngbTooltip="Have additional photos or files you'd like to include? Accepted file types: jpg, gif, png, pdf 
Max. file size: 512 MB."><i class="fa-solid fa-circle-question"></i></a></label>
                                        <input (change)="updateAttachments($event.target)" class="form-control" type="file" id="articleAtt" multiple>
                                    </div>
                                    <div *ngFor="let attachment of attachments; index as ind" class="attachmentBlock mb-3">
                                        <div class="fileType">
                                            <i class="fa-regular" [ngClass]="CommonLibrary.GetFileIconClass(attachment.type)"></i>
                                        </div>
                                        <div class="fileInfo">
                                            <span class="fileTitle">
                                                {{attachment.name}}
                                            </span>
                                            <span class="fileSize">
                                                {{attachment.size}}
                                            </span>
                                        </div>
                                        <div class="fileActions">
                                            <!--<a href="javascript:void(0);" class="mb-1"><i class="fa-regular fa-pen-to-square"></i></a-->
                                            <a (click)="removeAttachment(ind)" class="text-danger"><i class="fa-regular fa-times"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center mt-4">
                            <button (click)="submitNews()" type="button" class="btn btn-secondary m-100 newsSubmitBtn">Submit News Article</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>